module.exports = __webpack_public_path__ + "img/video_jp.670f247.jpg";